export default __webpack_public_path__ + "static/BuyLocalCampaign-62b3dd7f3f053ea27a0991443f62ac8f.jpg";